// ***** Sevices *****
import { readPatientHubioId } from '@services/patient';
// ***** Dependencies *****
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
// ***** Interfaces, Types and imports *****
import { BaseStateI } from '@interfaces/redux/base-state';

export interface PatientIdentifierState extends BaseStateI {
    patientIdentifier: string | null;
}

const fetchPatientIdentifier = createAsyncThunk(
    'patient/fetchPatientIdentifier',
    async (patientUsername: string, thunkAPI) => {
        const data = await readPatientHubioId(patientUsername);
        return data;
    }
);

const patientIdentifierSlice = createSlice({
    name: 'patient-identifier',
    initialState: {
        error: null,
        patientIdentifier: null,
        status: 'idle',
    } as PatientIdentifierState,
    reducers: {
        resetPatient: (state) => {
            state.error = null;
            state.patientIdentifier = null;
            state.status = 'idle';
        },
    },
    extraReducers: (builder) => {
        builder.addCase(fetchPatientIdentifier.pending, (state, action) => {
            state.status = 'loading';
        });
        builder.addCase(fetchPatientIdentifier.rejected, (state, action) => {
            state.status = 'failed';
            state.error = action.error;
        });
        builder.addCase(fetchPatientIdentifier.fulfilled, (state, action) => {
            state.status = 'succeeded';
            state.patientIdentifier = action.payload;
        });
    },
});

export const { resetPatient } = patientIdentifierSlice.actions;
export default patientIdentifierSlice.reducer;
